import { useTradingBalance } from "./use-trading-balance";
import { useWalletBalance } from "./use-wallet-balance";

export function useNeedsDepositToTrading(): boolean {
	const { balance: walletBalance } = useWalletBalance();
	const tradingBalance = useTradingBalance();

	return walletBalance > 0 && tradingBalance === 0;
}
